import React from 'react';
import '../CategoryProgress Bar/progressbar.css'


const CategoryProgress = ({ done }) => {
	const [style, setStyle] = React.useState({});

	setTimeout(() => {
		const newStyle = {
			opacity: 1,
			width: `${done}%`
		}

		setStyle(newStyle);
	}, 200);

	return (
		<div className="category-progress">
			<div className="category-progress-done" style={style}>
				{done}%
			</div>
		</div>
	)
}


export default CategoryProgress;